import { DeliveryListItem } from '@/modules/Logistics/interfaces/LogisticsInterfaces';
import moment from 'moment';
import i18n from '@/i18n';

// Re-export for backwards compatibility
export { DeliveryListItem };

/**
 * Filter delivery lists by search query
 */
export function filterDeliveryLists(lists: DeliveryListItem[], query: string): DeliveryListItem[] {
    if (!query) {
        return lists;
    }
    const lowerQuery = query.toLowerCase();
    return lists.filter(
        (item) =>
            item?.number?.toLowerCase().includes(lowerQuery) ||
            item?.driver?.toLowerCase().includes(lowerQuery) ||
            item?.vehicle?.toLowerCase().includes(lowerQuery) ||
            item?.date?.toLowerCase().includes(lowerQuery) ||
            item?.weekday?.toLowerCase().includes(lowerQuery) ||
            item?.id?.toString().includes(lowerQuery) ||
            item?.printed?.toLowerCase().includes(lowerQuery),
    );
}

/**
 * Table columns for delivery lists - Date, Weekday, Number, Driver, Auto, Printed
 */
export const DELIVERY_LIST_TABLE_COLUMNS = [
    {
        title: i18n.t('Delivery date'),
        dataIndex: 'date',
        key: 'date',
        sorter: (a: DeliveryListItem, b: DeliveryListItem) =>
            moment(a.date, 'DD.MM.YYYY').valueOf() - moment(b.date, 'DD.MM.YYYY').valueOf(),
        defaultSortOrder: 'descend' as const,
    },
    {
        title: i18n.t('Weekday'),
        dataIndex: 'weekday',
        key: 'weekday',
    },
    {
        title: i18n.t('Number'),
        dataIndex: 'number',
        key: 'number',
    },
    {
        title: i18n.t('Driver'),
        dataIndex: 'driver',
        key: 'driver',
    },
    {
        title: i18n.t('Vehicle'),
        dataIndex: 'vehicle',
        key: 'vehicle',
    },
    {
        title: i18n.t('Printed'),
        dataIndex: 'printed',
        key: 'printed',
    },
];

export const MONTAGE_TEAMS_TABLE_COLUMNS = [
    { title: i18n.t('Name'), dataIndex: 'name', key: 'name', type: 'string' as const },
    { title: i18n.t('Last Name'), dataIndex: 'lastName', key: 'lastName', type: 'string' as const },
    { title: i18n.t('Driver'), dataIndex: 'driver', key: 'driver', type: 'boolean' as const },
    { title: i18n.t('Team Leader'), dataIndex: 'teamLeader', key: 'teamLeader', type: 'boolean' as const },
    { title: i18n.t('Installer'), dataIndex: 'installer', key: 'installer', type: 'boolean' as const },
    { title: i18n.t('Vehicle'), dataIndex: 'vehicleRegistration', key: 'vehicleRegistration' },
];

export const MONTAGE_TEAMS_FORM_COLUMNS = [
    { title: i18n.t('Name'), dataIndex: 'name', key: 'name', type: 'string' as const },
    { title: i18n.t('Last Name'), dataIndex: 'lastName', key: 'lastName', type: 'string' as const },
    { title: i18n.t('Driver'), dataIndex: 'driver', key: 'driver', type: 'boolean' as const },
    { title: i18n.t('Team Leader'), dataIndex: 'teamLeader', key: 'teamLeader', type: 'boolean' as const },
    { title: i18n.t('Installer'), dataIndex: 'installer', key: 'installer', type: 'boolean' as const },
    { title: i18n.t('Vehicle'), dataIndex: 'vehicleId', key: 'vehicleId', type: 'dropdown' as const },
];

/**
 * Montage Teams table columns - Registracija (Registration), Tip (Type), Funkcija (Function), Voznik (Driver)
 */
export const VEHICLES_LIST_TABLE_COLUMNS = [
    { title: i18n.t('Registration'), dataIndex: 'registration', key: 'registration', type: 'string' as const },
    { title: i18n.t('Type'), dataIndex: 'type', key: 'type', type: 'dropdown' as const },
    { title: i18n.t('Purpose'), dataIndex: 'purpose', key: 'purpose', type: 'dropdown' as const },
    { title: i18n.t('Driver'), dataIndex: 'driver', key: 'driver', type: 'readonly' as const },
];

export const VEHICLE_TYPE_OPTIONS = [
    { value: 'Kombi', label: i18n.t('Van') },
    { value: 'Kamion', label: i18n.t('Truck') },
];

export const VEHICLE_PURPOSE_OPTIONS = [
    { value: 'Montaža', label: i18n.t('Installation') },
    { value: 'Razvoz', label: i18n.t('Montage Delivery') },
];
